import React from 'react';
import {
  Alert,
  AlertTitle,
  CircularProgress,
  IconButton,
  Snackbar,
  Typography,
} from '@mui/material';
import { Close, CheckCircleOutline, ErrorOutline } from '@mui/icons-material';

export interface CreateMessageStatusProps {
  loading: boolean;
  open: boolean;
  creatingMessage: boolean;
  creatingMessageError: boolean;
  attachments: { pending: number; created: number; failed: number };
  close: Function;
  edit?: boolean;
  cancel?: boolean;
}

export const CreateMessageStatus = ({
  loading,
  open,
  creatingMessage,
  creatingMessageError,
  attachments,
  close,
  edit = false,
  cancel = false,
}: CreateMessageStatusProps) => {
  const content = (
    <Alert
      variant="filled"
      severity="success"
      sx={
        attachments.failed > 0 || creatingMessageError
          ? { backgroundColor: 'warning.main' }
          : { backgroundColor: 'secondary.main' }
      }
      icon={
        loading ? (
          <CircularProgress color="inherit" size={22} />
        ) : creatingMessageError ? (
          <ErrorOutline fontSize="inherit" />
        ) : (
          <CheckCircleOutline fontSize="inherit" />
        )
      }
      action={
        loading ? (
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {
              close();
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        ) : (
          <></>
        )
      }
    >
      <AlertTitle>
        <Typography variant="h6">
          {creatingMessage
            ? edit
              ? cancel
                ? 'Canceling Message...'
                : 'Editing Message...'
              : 'Creating Message...'
            : attachments.failed > 0 && !creatingMessageError
            ? edit
              ? cancel
                ? 'Canceled Message had Errors...'
                : 'Edited Message with Errors'
              : 'Created Message with Errors'
            : creatingMessageError
            ? edit
              ? cancel
                ? 'Error Canceling Message'
                : 'Error Editing Message'
              : 'Error Creating Message'
            : edit
            ? cancel
              ? 'Canceled Message'
              : 'Edited Message'
            : 'Created Message'}
        </Typography>
      </AlertTitle>
      <Typography variant="subtitle2">
        {edit
          ? cancel
            ? 'The message was canceled successfully'
            : 'The message was edited successfully'
          : 'The message was created successfully'}
      </Typography>
      {attachments.created + attachments.pending + attachments.failed > 0 && (
        <Typography variant="subtitle2">
          {attachments.pending > 0 ? 'Uploading' : 'Uploaded'} Message
          Attachments: {attachments.created}/
          {attachments.created + attachments.pending + attachments.failed}{' '}
          succeeded &nbsp;&nbsp;&nbsp;{' '}
          {attachments.failed > 0 && `${attachments.failed} FAILED!`}
        </Typography>
      )}
    </Alert>
  );

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      autoHideDuration={!loading ? 3000 : null}
      onClose={() => close()}
      message={content}
      open={open}
      ContentProps={{
        sx:
          attachments.failed > 0 || creatingMessageError
            ? { backgroundColor: 'warning.main' }
            : { backgroundColor: 'secondary.main' },
      }}
      action={
        !loading ? (
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {
              close();
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        ) : (
          <></>
        )
      }
    />
  );
};
